module.exports = __webpack_public_path__ + "img/no-q_home_image_map.3c6d25d2.png";